































import {Component, Prop, Vue} from 'vue-property-decorator';
import {DncFamilyGroupFails} from '@/modules/neovehicle/models/dnc';

@Component
export default class extends Vue {
  @Prop({required: true})
  public dncFamilyGroupFails: DncFamilyGroupFails[];

  @Prop({required: true})
  public isOpen: boolean;

  public isOpenInternal: boolean = false;

  public headers = [
    {text: 'Bandeira', value: 'brandname', show: true},
    {text: 'Dnc Família Grupo', value: 'name', show: true},
    {text: 'Famílias', value: 'families', show: true},
  ];

  public async mounted() {
    this.isOpenInternal = this.isOpen;
  }

  public handleCancel() {
    this.$emit('cancel');
  }
}
